export const HEADER_CELL_WIDTH = "26.5rem";
export const HEADER_CELL_WIDTH_MOBILE = "10.6rem";
export const HEADER_CELL_WIDTH = "26.5rem";
export const HEADER_CELL_WIDTH_MOBILE = "10.6rem";
